import React, { useState, useEffect } from "react";
import ReactStars from "react-rating-stars-component";
import { toast } from "react-toastify";
import { Link, useParams } from "react-router-dom";
import { Colxx } from "../../../../../components/common/CustomBootstrap";
import "react-treeview/react-treeview.css";
import { JobService } from "../../../../../services/JobService";
import {
  Row,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Form,
  FormGroup,
} from "reactstrap";
import { getEnumLists } from "../../../../../services/MetadataService";
import $ from "jquery";

const LanguagesList = (props) => {
  var { id } = useParams();
  const [modalRight, setModalRight] = useState(false);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [languageshow, setlanguageShow] = useState(true);
  const [categories, setCategories] = useState([]);
  const [show, setShow] = useState();
  const [rating, setRating] = useState(0);

  const [selectedSoftSkills, setSelectedSoftSkills] = useState([]);

  const [scategories, setSCategories] = useState([]);
  const [buttonShow, setButtonShow] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [writtenSelectedSkills, setWrittenSelectedSkills] = useState([]);
  const [pageSize, setPageSize] = useState(110);
  const [selectedSpokenId, setSelectedSpokenId] = useState([]);
  const [selectedWrittenId, setSelectedWrittenId] = useState([]);
  const [languageid, setlanguageid] = useState("");
  const [languagename, setlanguagename] = useState("");
  const [sortOrder, setSortOrder] = useState("ASC");
  const [languageLevels, setLanguageLevels] = useState([]);
  const [jobStatus, setJobStatus] = useState("");
  const [ratingSpokenSelectedList, setRatingSpokenSelectedList] = useState([]);
  const [ratingWriteSelectedList, setRatingWriteSelectedList] = useState([]);

  useEffect(() => {
    getJobEnums();
    getLanguagesList();
     if (id != 0) {
      getJobDetails(id);
      getReqLanguagesList();
    }
  }, []);

  const getJobEnums = () => {
    getEnumLists().then((response) => {
      try {
        if (response !== null) {
          let languageLevels=response.languageLevels;
          if(languageLevels!=null){
            const skillLevel = languageLevels.reverse();
          setLanguageLevels(skillLevel);
          }
        }
      } catch (err) {}
    });
  };

  const getJobDetails = (jobId) => {
    var jobDetails = props.jobDetails;
    if (jobDetails != null) {
      if (jobDetails.jobStatus !== null || jobDetails.jobStatus !== "") {
        setJobStatus(jobDetails.jobStatus.key);
      }
    }
    // JobService.getJob(jobId).then((response) => {
    //   try {
    //     if (response.message != null) {
    //       if (response.data.error_message !== "") {
    //       }
    //     } else {
    //       var jobDetails = response.data;
    //       if (jobDetails != null) {
    //         if (jobDetails.jobStatus !== null || jobDetails.jobStatus !== "") {
    //           setJobStatus(jobDetails.jobStatus.key);
    //         }
    //       }
    //     }
    //   } catch (err) {}
    // });
  };

  const getLanguagesList = () => {
    JobService.getLanguageService(pageSize, sortOrder).then((response) => {
     
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          var languageDetails = response.data;

          if (languageDetails != null) {
            setCategories(languageDetails.skills);
            setFilteredCategories(languageDetails.skills);

            languageDetails.skill.map((skill, index) => {
              languageDetails.skill[index].ratingSpoken = 0;
              languageDetails.skill[index].ratingWritten = 0;
              languageDetails.skill[index].spokenLevel = "";
              languageDetails.skill[index].writtenLevel = "";
            });
            setCategories(languageDetails.skills);
            setFilteredCategories(languageDetails.skills);
          }
        }
      } catch (err) {}
    });
  };

  const getReqLanguagesList = () => {
    JobService.getReqLanguagesService(id).then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          var languageDetails = response.data;
          if (languageDetails != null) {
            setSCategories(response.data.languages);
          }
        }
      } catch (err) {}
    });
  };

  const onSpokenRatingChanged = (newRating, id, index) => {
    let spokenRatingList = [...ratingSpokenSelectedList];

    if (spokenRatingList.length > 0) {
      spokenRatingList.map(spokenRating=>{
        spokenRating.isSpokenRated = false;
      })
    }

    setRating(newRating);
    for (var i = 0; i < selectedSoftSkills.length; i++) {
      if (selectedSoftSkills[i].skillId == id) {
        selectedSoftSkills[i].ratingSpoken = newRating;
        break;
      }
    }

    if (spokenRatingList.length > 0) {
      const isFound = spokenRatingList.some((element) => {
        if (element.skillId === id) {
          return true;
        }
        return false;
      });

      if (isFound) {
        for (let i = 0; i < spokenRatingList.length; i++) {
          if (spokenRatingList[i].skillId == id) {
            spokenRatingList[i].skillId = id;
            spokenRatingList[i].ratingSpoken = newRating;
            spokenRatingList[i].isSpokenRated = true;
          } else {
            spokenRatingList[i].isSpokenRated = false;
          }
        }
      } else {
        ratingSpokenSelectedList.push({
          skillId: id,
          ratingSpoken: newRating,
          isSpokenRated: true,
        });
      }
    } else {
      ratingSpokenSelectedList.push({
        skillId: id,
        ratingSpoken: newRating,
        isSpokenRated: true,
      });
    }
    setRatingSpokenSelectedList(ratingSpokenSelectedList);

    if (ratingWriteSelectedList.length > 0) {
      let ratingList = [...ratingWriteSelectedList];
      for (let i = 0; i < ratingList.length; i++) {
        ratingList[i].isWrittenRated = false;
      }
      setRatingWriteSelectedList(ratingList);
    }

    filteredCategories[index].ratingSpoken = newRating;
    setFilteredCategories(filteredCategories);
  };

  const childSpokenHandleCheck = (event, language) => {
    var updatedList = [...selectedSkills];

    if (event.target.checked) {
      updatedList.push(language.skillId);

      if (selectedSoftSkills.length > 0) {
        const isFound = selectedSoftSkills.some((element) => {
          if (element.skillId === language.skillId) {
            selectedSpokenId.push({
              skillId: language.skillId,
            });
            return true;
          }
          return false;
        });
        if (isFound) {
          for (let i = 0; i < selectedSoftSkills.length; i++) {
            if (selectedSoftSkills[i].skillId == language.skillId) {
              selectedSoftSkills[i].skillId = language.skillId;
              selectedSoftSkills[i].spoken = true;
              selectedSoftSkills[i].ratingSpoken = 0;
            }
          }
        } else {
          selectedSoftSkills.push({
            skillId: language.skillId,
            spoken: true,
            ratingSpoken: 0,
          });

          selectedSpokenId.push({
            skillId: language.skillId,
          });
        }
      } else {
        selectedSoftSkills.push({
          skillId: language.skillId,
          spoken: true,
          ratingSpoken: 0,
        });
        selectedSpokenId.push({
          skillId: language.skillId,
        });
      }
    } else {
      for (let i = 0; i < updatedList.length; i++) {
        if (updatedList[i] == language.skillId) {
          updatedList.splice(i, 1);
          selectedSpokenId.splice(i, 1);
        }
      }
      const isFound = selectedSoftSkills.some((element) => {
        if (element.skillId === language.skillId) {
          return true;
        }
        return false;
      });

      if (isFound) {
        for (let i = 0; i < selectedSoftSkills.length; i++) {
          if (selectedSoftSkills[i].skillId == language.skillId) {
            selectedSoftSkills[i].spoken = false;
            selectedSoftSkills[i].ratingSpoken = 0;
          }
        }
      }
    }

    if (ratingSpokenSelectedList.length > 0) {
      const ratingList = [...ratingSpokenSelectedList];
      for (let i = 0; i < ratingList.length; i++) {
        if (ratingList[i].skillId == language.skillId) {
          if (!event.target.checked) {
            ratingList[i].ratingSpoken = 0;
          }
        }
      }
      setRatingSpokenSelectedList(ratingList);
    }

    setSelectedSkills(updatedList);
  };

  const childWrittenHandleCheck = (event, language) => {
    var updatedList = [...writtenSelectedSkills];
    if (event.target.checked) {
      updatedList.push(language.skillId);
      if (selectedSoftSkills.length > 0) {
        const isFound = selectedSoftSkills.some((element) => {
          if (element.skillId === language.skillId) {
            selectedWrittenId.push({
              skillId: language.skillId,
            });
            return true;
          }
          return false;
        });
        if (isFound) {
          for (let i = 0; i < selectedSoftSkills.length; i++) {
            if (selectedSoftSkills[i].skillId == language.skillId) {
              selectedSoftSkills[i].skillId = language.skillId;
              selectedSoftSkills[i].written = true;
              selectedSoftSkills[i].ratingWritten = 0;
            }
          }
        } else {
          selectedSoftSkills.push({
            skillId: language.skillId,
            written: true,
            ratingWritten: 0,
          });
          selectedWrittenId.push({
            skillId: language.skillId,
          });
        }
      } else {
        selectedSoftSkills.push({
          skillId: language.skillId,
          written: true,
          ratingWritten: 0,
        });
        selectedWrittenId.push({
          skillId: language.skillId,
        });
      }
    } else {
      const isFound = selectedSoftSkills.some((element) => {
        if (element.skillId === language.skillId) {
          return true;
        }
        return false;
      });

      if (isFound) {
        for (let i = 0; i < selectedSoftSkills.length; i++) {
          if (selectedSoftSkills[i].skillId == language.skillId) {
            selectedSoftSkills[i].written = false;
            selectedSoftSkills[i].ratingWritten = 0;
          }
        }
      }
      for (let i = 0; i < updatedList.length; i++) {
        if (updatedList[i] == language.skillId) {
          updatedList.splice(i, 1);
          selectedWrittenId.splice(i, 1);
        }
      }
    }

    if (ratingWriteSelectedList.length > 0) {
      const ratingList = [...ratingWriteSelectedList];
      for (let i = 0; i < ratingList.length; i++) {
        if (ratingList[i].skillId == language.skillId) {
          if (!event.target.checked) {
            ratingList[i].ratingWritten = 0;
          }
        }
      }
      setRatingWriteSelectedList(ratingList);
    }
    setWrittenSelectedSkills(updatedList);
  };

  const onWriteRatingChanged = (newRating, id, index) => {
    let writtenRatingSelectedList = [...ratingWriteSelectedList];

    if (writtenRatingSelectedList.length > 0) {
      writtenRatingSelectedList.map(writtenRating=>{
        writtenRating.isWrittenRated = false;
      })
    }

    setRating(newRating);
    for (var i = 0; i < selectedSoftSkills.length; i++) {
      if (selectedSoftSkills[i].skillId == id) {
        selectedSoftSkills[i].ratingWritten = newRating;
        break;
      }
    }

    if (writtenRatingSelectedList.length > 0) {
      const isFound = writtenRatingSelectedList.some((element) => {
        if (element.skillId === id) {
          return true;
        }
        return false;
      });

      if (isFound) {
        for (let i = 0; i < writtenRatingSelectedList.length; i++) {
          if (writtenRatingSelectedList[i].skillId == id) {
            writtenRatingSelectedList[i].skillId = id;
            writtenRatingSelectedList[i].ratingWritten = newRating;
            writtenRatingSelectedList[i].isWrittenRated = true;
          } else {
            writtenRatingSelectedList[i].isWrittenRated = false;
          }
        }
      } else {
        ratingWriteSelectedList.push({
          skillId: id,
          ratingWritten: newRating,
          isWrittenRated: true,
        });
      }
    } else {
      ratingWriteSelectedList.push({
        skillId: id,
        ratingWritten: newRating,
        isWrittenRated: true,
      });
    }
    setRatingWriteSelectedList(ratingWriteSelectedList);

    if (ratingSpokenSelectedList.length > 0) {
      const ratingList = [...ratingSpokenSelectedList];
      for (let i = 0; i < ratingList.length; i++) {
        ratingList[i].isSpokenRated = false;
      }
      setRatingSpokenSelectedList(ratingList);
    }

    filteredCategories[index].ratingWritten = newRating;
    setFilteredCategories(filteredCategories);
  };

  function handlelanguagekillsSelectChange(e, id) {
    for (var i = 0; i < selectedSoftSkills.length; i++) {
      if (selectedSoftSkills[i].skillId == id) {
        selectedSoftSkills[i].spokenLevel = e.target.value;
        // break;
      }
    }
    setSelectedSoftSkills(selectedSoftSkills);

    const languages = [...filteredCategories];
    languages.map((language, index) => {
      if (language.skillId == id) {
        language.spokenLevel = e.target.value;
      }
    });
    setFilteredCategories(languages);
  }

  function handlelanguagekillsWrittenSelectChange(e, id) {
    for (var i = 0; i < selectedSoftSkills.length; i++) {
      if (selectedSoftSkills[i].skillId == id) {
        selectedSoftSkills[i].writtenLevel = e.target.value;
        // break;
      }
    }
    setSelectedSoftSkills(selectedSoftSkills);

    const languages = [...filteredCategories];
    languages.map((language, index) => {
      if (language.skillId == id) {
        language.writtenLevel = e.target.value;
      }
    });
    setFilteredCategories(languages);
  }

  const saveReqLanguages = () => {
    const jobId = window.localStorage.getItem("requestId");
    if (jobId == "") {
      toast.error("Please fill basic info");
      return;
    }

    const langSelectedList = [];

    for (let i = 0; i < selectedSoftSkills.length; i++) {
      if (selectedSoftSkills[i].spoken !== null) {
        if (selectedSoftSkills[i].spoken) {
          if (selectedSoftSkills[i].ratingSpoken == 0) {
            toast.error("Please rate your selected languages or unselect them");
            return;
          }
        }
      }

      if (selectedSoftSkills[i].written !== null) {
        if (selectedSoftSkills[i].written) {
          if (selectedSoftSkills[i].ratingWritten == 0) {
            toast.error("Please rate your selected languages or unselect them");
            return;
          }
        }
      }

      if (
        selectedSoftSkills[i].spoken != null &&
        selectedSoftSkills[i].written == null
      ) {
        if (selectedSoftSkills[i].spoken == true) {
          langSelectedList.push(selectedSoftSkills[i]);
        }
      } else if (
        selectedSoftSkills[i].written != null &&
        selectedSoftSkills[i].spoken == null
      ) {
        if (selectedSoftSkills[i].written == true) {
          langSelectedList.push(selectedSoftSkills[i]);
        }
      } else if (
        selectedSoftSkills[i].written != null &&
        selectedSoftSkills[i].spoken != null
      ) {
        if (
          selectedSoftSkills[i].spoken == true ||
          selectedSoftSkills[i].written == true
        ) {
          langSelectedList.push(selectedSoftSkills[i]);
        }
      } else if (
        selectedSoftSkills[i].written == null &&
        selectedSoftSkills[i].spoken == null
      ) {
      }
    }

    const languageobject = {
      languages: langSelectedList,
    };

    if (langSelectedList.length > 0) {
      JobService.updateJobReqLanguagesService(languageobject).then(
        (response) => {
          toast.success("Languages added successfully");
          setSCategories([]);
          setModalRight(false);
          getReqLanguagesList();
        }
      );
    } else {
      toast.error("Please select language");
    }
  };

  const searchItems = (searchValue) => {
    if (searchValue !== "") {
      if (searchValue.length >= 2) {
        JobService.searchLanguages(searchValue).then((response) => {
         
          try {
            if (response.message != null) {
              if (response.data.error_message !== "") {
              }
            } else {
              var languageDetails = response.data;
              if (languageDetails != null) {
                if (languageDetails.skills.length > 0) {
                  var languageSkills = languageDetails.skills;
                  languageSkills.map((skill, index) => {
                    skill.ratingSpoken = 0;
                    skill.ratingWritten = 0;
                    skill.spokenLevel = "";
                    skill.writtenLevel = "";
                  });
                  setlanguageShow(true);

                  updateLanguageSkills(languageSkills);
                } else {
                  setFilteredCategories([]);
                }
              }
            }
          } catch (err) {}
        });
      } else {
        updateLanguageSkills(categories);
      }
    } else {
      updateLanguageSkills(categories);
    }
  };

  const updateLanguageSkills = (languageSkills) => {
    if (languageSkills.length > 0) {
      languageSkills.map((skill, index) => {
        if (ratingSpokenSelectedList.length > 0) {
          for (let i = 0; i < ratingSpokenSelectedList.length; i++) {
            var selectedSkillId = ratingSpokenSelectedList[i].skillId;
            var ratingSpoken = ratingSpokenSelectedList[i].ratingSpoken;
            if (skill.skillId == selectedSkillId) {
              skill.ratingSpoken = ratingSpoken;
            }
          }
        }

        if (ratingWriteSelectedList.length > 0) {
          for (let j = 0; j < ratingWriteSelectedList.length; j++) {
            var selectedSkillId = ratingWriteSelectedList[j].skillId;
            var ratingWritten = ratingWriteSelectedList[j].ratingWritten;
            if (skill.skillId == selectedSkillId) {
              skill.ratingWritten = ratingWritten;
            }
          }
        }

        if (selectedSoftSkills.length > 0) {
          for (let k = 0; k < selectedSoftSkills.length; k++) {
            var selectedSkillId = selectedSoftSkills[k].skillId;
            var spokenLevel = selectedSoftSkills[k].spokenLevel;
            var writtenLevel = selectedSoftSkills[k].writtenLevel;

            if (skill.skillId == selectedSkillId) {
              skill.spokenLevel = spokenLevel;
              skill.writtenLevel = writtenLevel;
            }
          }
        }
      });

      setFilteredCategories(languageSkills);
    } else {
      setFilteredCategories([]);
    }
  };

  const onAddLanguages = () => {
    setRatingWriteSelectedList([]);
    setRatingSpokenSelectedList([]);

    setSelectedSpokenId([]);
    setSelectedWrittenId([]);
    setSelectedSoftSkills([]);
    setModalRight(true);
    // setFilteredCategories(categories);
    setlanguageShow(true);
    setSelectedSkills([]);
    setWrittenSelectedSkills([]);
    // resetSkillsList();
    resetSkillsListDetails();
  };

  const resetSkillsListDetails = () => {
    let categoriesList = [...categories];
    categoriesList.map((skill, index) => {
      skill.ratingSpoken = 0;
      skill.ratingWritten = 0;
      skill.spokenLevel = "";
      skill.writtenLevel = "";
    });
    updatedLanguageSkills(categoriesList);
  };

  const updatedLanguageSkills = (categoriesList) => {
    let updatedSpokenList = [];
    let updatedWrittenList = [];
    let selectedSpokenIdsList = [];

    let selectedWrittenIdsList = [];
    let selectedSoftSkillsList = [];

    let ratingSpokengList = [];
    let ratingWrittenList = [];

    if (scategories.length > 0) {
      scategories.map((category, index) => {
        let skillId = category.skillId;
        let spoken = category.spoken;
        let written = category.written;
        let ratingSpoken = category.ratingSpoken;
        let ratingWritten = category.ratingWritten;

        let spokenLevel = "";
        if (category.spokenLevel !== null) {
          let spokenLevelKey = category.spokenLevel.key;
          spokenLevel = spokenLevelKey;
        }

        let writtenLevel = "";
        if (category.writtenLevel !== null) {
          let writtenLevelKey = category.writtenLevel.key;
          writtenLevel = writtenLevelKey;
        }

        selectedSoftSkillsList.push({
          skillId: skillId,
          spoken: spoken,
          written: written,
          ratingSpoken: ratingSpoken,
          ratingWritten: ratingWritten,
          spokenLevel: spokenLevel,
          writtenLevel: writtenLevel,
        });

        if (spoken) {
          updatedSpokenList.push(skillId);
          selectedSkills.push(skillId);
          ratingSpokengList.push({
            skillId: skillId,
            ratingSpoken: ratingSpoken,
          });
        }

        if (written) {
          updatedWrittenList.push(skillId);
          ratingWrittenList.push({
            skillId: skillId,
            ratingWritten: ratingWritten,
          });
        }

        const isFound = categoriesList.some((element) => {
          if (element.skillId === skillId) {
            selectedSpokenId.push({
              skillId: skillId,
            });
            return true;
          }
          return false;
        });

        if (isFound) {
          categoriesList.map((skill) => {
            let categorySKillId = skill.skillId;
            if (categorySKillId == skillId) {
              skill.ratingSpoken = ratingSpoken;
              skill.ratingWritten = ratingWritten;
              skill.spokenLevel = spokenLevel;
              skill.writtenLevel = writtenLevel;
            }
          });
        }
      });
    }
    setRatingSpokenSelectedList(ratingSpokengList);
    setRatingWriteSelectedList(ratingWrittenList);
    setSelectedSpokenId(selectedSpokenIdsList);
    setSelectedSkills(updatedSpokenList);
    setWrittenSelectedSkills(updatedWrittenList);
    setFilteredCategories(categoriesList);
    setSelectedSoftSkills(selectedSoftSkillsList);
  };

  const resetSkillsList = () => {
    categories.length > 0 &&
      categories.map((skill, index) => {
        skill.ratingSpoken = 0;
        skill.ratingWritten = 0;
        skill.spokenLevel = "";
        skill.writtenLevel = "";
      });
    setCategories(categories);
    setFilteredCategories(categories);
  };

  const seeFullList = () => {
    setlanguageShow((prev) => !prev);
    setButtonShow((prev) => !prev);
    setFilteredCategories(categories);
  };

  const handlelanguageid = (deleteId, name) => {
    setlanguageid(deleteId);
    setlanguagename(name);
  };

  const removeSkillDetails = () => {
    JobService.removeReqLanguageService(languageid,id).then((response) => {
      toast.success("Language deleted successfully");
      getReqLanguagesList();
    });
  };

  const setWrittenRatingValues = (skillId) => {
    let ratingValue = 0;

    if (ratingWriteSelectedList.length > 0) {
      const isFound = ratingWriteSelectedList.some((element) => {
        if (element.skillId === skillId) {
          return true;
        }
        return false;
      });

      if (isFound) {
        for (let i = 0; i < ratingWriteSelectedList.length; i++) {
          if (ratingWriteSelectedList[i].skillId == skillId) {
            return ratingWriteSelectedList[i].ratingWritten;
          }
        }
      } else {
        ratingValue = 0;
      }
    } else {
      ratingValue = 0;
    }
  };

  const setSpokenRatingValues = (skillId) => {
    let ratingValue = 0;

    if (ratingSpokenSelectedList.length > 0) {
      const isFound = ratingSpokenSelectedList.some((element) => {
        if (element.skillId === skillId) {
          return true;
        }
        return false;
      });

      if (isFound) {
        for (let i = 0; i < ratingSpokenSelectedList.length; i++) {
          if (ratingSpokenSelectedList[i].skillId == skillId) {
            return ratingSpokenSelectedList[i].ratingSpoken;
          }
        }
      } else {
        ratingValue = 0;
      }
    } else {
      ratingValue = 0;
    }
  };

  const spokenRatingDialog = (skillId) => {
    var uniqueId = skillId;
    let ratingValue = 0;
    let isRated = false;
    if (ratingSpokenSelectedList.length > 0) {
      for (let i = 0; i < ratingSpokenSelectedList.length; i++) {
        if (ratingSpokenSelectedList[i].skillId == skillId) {
          ratingValue = ratingSpokenSelectedList[i].ratingSpoken;
          isRated = ratingSpokenSelectedList[i].isSpokenRated;

          if (isRated) {
            ratingSpokenSelectedList[i].isSpokenRated = false;
            if (ratingValue == 1) {
              $("#" + skillId + "spokenRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Beginner";
            } else if (ratingValue == 2) {
              $("#" + skillId + "spokenRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Intermediate";
            } else if (ratingValue == 3) {
              $("#" + skillId + "spokenRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Proficient";
            } else if (ratingValue == 4) {
              $("#" + skillId + "spokenRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Advanced";
            } else if (ratingValue == 5) {
              $("#" + skillId + "spokenRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Expert";
            }
          }
        }
      }
    } else {
      ratingValue = 0;
    }
  };

  const writtenRatingDialog = (skillId) => {
    var uniqueId = skillId;
    let ratingValue = 0;
    let isRated = false;
    if (ratingWriteSelectedList.length > 0) {
      for (let i = 0; i < ratingWriteSelectedList.length; i++) {
        if (ratingWriteSelectedList[i].skillId == skillId) {
          ratingValue = ratingWriteSelectedList[i].ratingWritten;
          isRated = ratingWriteSelectedList[i].isWrittenRated;
          if (isRated) {
            ratingWriteSelectedList[i].isWrittenRated = false;
            if (ratingValue == 1) {
              $("#" + skillId + "writtenRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Beginner";
            } else if (ratingValue == 2) {
              $("#" + skillId + "writtenRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Intermediate";
            } else if (ratingValue == 3) {
              $("#" + skillId + "writtenRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Proficient";
            } else if (ratingValue == 4) {
              $("#" + skillId + "writtenRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Advanced";
            } else if (ratingValue == 5) {
              $("#" + skillId + "writtenRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Expert";
            }
          }
        }
      }
    } else {
      ratingValue = 0;
    }
  };

  return (
    <div>
      <div className="skill-header">
        <div>
          <div className="profile-card-title">
            <label>
              <strong>
                <h2>Languages</h2>
              </strong>
            </label>
          </div>
        </div>
        <div>
          {jobStatus != "CLOSED" && (
            <Button
              color="primary"
              size="sm"
              disabled={
                window.localStorage.getItem("view") === "view" ? true : false
              }
              outline
              onClick={onAddLanguages}
            >
              Add Languages
            </Button>
          )}
        </div>
      </div>

      <div>
        <Modal
          scrollable={true}
          isOpen={modalRight}
          toggle={() => setModalRight(!modalRight)}
          wrapClassName="modal-right"
          className="language-model-width"
        >
          <ModalHeader className="mdl_header">
            <div>
              <strong>Add and rate job languages</strong>
            </div>
          </ModalHeader>
          <ModalBody className="labelSize">
            <div className="col-lg-12 p-0">
              <Input
                type="text"
                id="search"
                icon="search"
                placeholder="Search for languages"
                onChange={(e) => searchItems(e.target.value)}
              />
            </div>
            {languageshow &&
              filteredCategories.length > 0 &&
              filteredCategories.map((skill, index) => {
                return (
                  <div className="col-12" key={skill.id}>
                    <label id="skillName">{skill.description}</label>
                    <i className="p-4">{skill.synonyms}</i>

                    <div className="col-12">
                      <div className="col-12">
                        <div className="row">
                          <div className="col-sm-3 mt-2">
                            <label className="row">
                              <input
                                id="skillId"
                                type="checkbox"
                                className="input_skill"
                                checked={selectedSkills.find(
                                  (ch) => ch === skill.skillId
                                )}
                                onChange={(e) =>
                                  childSpokenHandleCheck(e, skill)
                                }
                                onClick={() => setShow((checked) => !checked)}
                              />
                              <div className="terms">Spoken </div>
                            </label>
                          </div>
                          {selectedSkills.find((ch) => ch === skill.skillId) ? (
                            <>
                              <div className="col-sm-5 mb-2">
                                <Input
                                  width="5"
                                  type="select"
                                  id={skill.skillId + "_levelSpoken"}
                                  value={skill.spokenLevel}
                                  onChange={(e) =>
                                    handlelanguagekillsSelectChange(
                                      e,
                                      skill.skillId
                                    )
                                  }
                                >
                                  {languageLevels.map(({ value, key }) => (
                                    <option value={key}>{value}</option>
                                  ))}
                                </Input>
                              </div>

                              <div className="col-sm-4">
                                <div className="peerrating">
                                  <ReactStars
                                    count={5}
                                    id={skill.skillId + "_spokenrating"}
                                    size={24}
                                    activeColor="#ffd700"
                                    value={setSpokenRatingValues(skill.skillId)}
                                    onChange={(e) =>
                                      onSpokenRatingChanged(
                                        e,
                                        skill.skillId,
                                        index
                                      )
                                    }
                                  />{" "}
                                  <span
                                    className="t-status-pad-st t-text-[13px]"
                                    id={skill.skillId + "spokenRatingMessage"}
                                  >
                                    {spokenRatingDialog(skill.skillId)}
                                  </span>
                                </div>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="row">
                          <div className="col-3">
                            <div className="tracbox mt-2">
                              <label className="row">
                                <input
                                  id="skillname"
                                  type="checkbox"
                                  className="input_skill"
                                  checked={writtenSelectedSkills.find(
                                    (ch) => ch === skill.skillId
                                  )}
                                  onChange={(e) =>
                                    childWrittenHandleCheck(e, skill)
                                  }
                                />

                                <div className="terms">Written </div>
                              </label>
                            </div>
                          </div>

                          {writtenSelectedSkills.find(
                            (ch) => ch === skill.skillId
                          ) ? (
                            <>
                              <div className="col-sm-5 mb-2">
                                <Input
                                  width="5"
                                  type="select"
                                  id={skill.skillId + "_levelWritten"}
                                  value={skill.writtenLevel}
                                  onChange={(e) =>
                                    handlelanguagekillsWrittenSelectChange(
                                      e,
                                      skill.skillId
                                    )
                                  }
                                >
                                  {languageLevels.map(({ value, key }) => (
                                    <option value={key}>{value}</option>
                                  ))}
                                </Input>
                              </div>

                              <div className="col-4">
                                <div className="peerrating">
                                  <ReactStars
                                    count={5}
                                    id={skill.skillId + "_writtenrating"}
                                    size={24}
                                    value={setWrittenRatingValues(
                                      skill.skillId
                                    )}
                                    activeColor="#ffd700"
                                    onChange={(e) =>
                                      onWriteRatingChanged(
                                        e,
                                        skill.skillId,
                                        index
                                      )
                                    }
                                  />{" "}
                                  <span
                                    className="t-status-pad-st t-text-[13px]"
                                    id={skill.skillId + "writtenRatingMessage"}
                                  >
                                    {writtenRatingDialog(skill.skillId)}
                                  </span>
                                </div>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            {filteredCategories.length == 0 && (
              <div className="t-nodata  mt-4">
                <strong>Language not found</strong>
              </div>
            )}
          </ModalBody>
          <ModalFooter className="p-4">
            <Button
              color="primary"
              size="sm"
              outline
              onClick={saveReqLanguages}
            >
              Save
            </Button>{" "}
            <Button
              color="primary"
              size="sm"
              outline
              onClick={() => setModalRight(false)}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
      {scategories.length > 0 && (
        <Card className="mt-4">
          <CardBody>
            {scategories.map((skill, index) => {
              return (
                <Row key={index}>
                  <Colxx xxs="12">
                    <Form>
                      <FormGroup row>
                        <Colxx sm={3}>
                          <label>
                            <div id="skillname" className="terms">
                              {skill.description}
                            </div>
                          </label>
                        </Colxx>
                        <Colxx sm={4}>
                          <Row>
                            <div className="tracbox mt-1">
                              <input
                                id="spoken"
                                readOnly
                                type="checkbox"
                                className="input_skill"
                                checked={skill.spoken}
                                //onChange={(e) => childWrittenHandleCheck(e, skill)}
                              />
                              <label>
                                <div className="terms mr-2">Spoken</div>
                              </label>
                            </div>

                            <ReactStars
                              count={5}
                              size={20}
                              edit={false}
                              value={skill.ratingSpoken}
                              activeColor="#FFD700"
                              id={skill.skillId + "_spoken_rating"}
                              // onChange={(e) =>
                              //     spokenRatingUpdatedChanged(e, skill)
                              // }
                            />
                          </Row>
                        </Colxx>
                        <Colxx sm={3}>
                          <Row>
                            <div className="tracbox mt-1">
                              <input
                                id="written"
                                type="checkbox"
                                className="input_skill"
                                checked={skill.written}
                                readOnly
                                //onChange={(e) => childWrittenHandleCheck(e, skill)}
                              />
                              <label>
                                <div id="writtenLabel" className="terms mr-2">
                                  Written
                                </div>
                              </label>
                            </div>
                            <ReactStars
                              count={5}
                              size={20}
                              edit={false}
                              value={skill.ratingWritten}
                              activeColor="#FFD700"
                              id={skill.skillId + "_written_rating"}
                              // onChange={(e) =>
                              //     writtenRatingUpdatedChanged(e, skill)
                              // }
                            />
                          </Row>
                        </Colxx>
                        <Colxx sm={2}>
                          {window.localStorage.getItem("view") === "view" ? (
                            <Link
                              className="disabledCursor ml-2"
                              onClick={(event) => event.preventDefault()}
                            >
                              <>
                                <i className="emp_icon" />
                              </>
                            </Link>
                          ) : (
                            <div>
                              <span className="notDisabled ml-2 t-cursor-pointer">
                                <>
                                  {jobStatus != "CLOSED" && (
                                    <i
                                      type="button"
                                      data-toggle="modal"
                                      data-target="#exampleModalmiddle"
                                      className="simple-icon-trash edit-copyiconsize arrow-icon-color mr-1 mb-2 emp_icon"
                                      onClick={() =>
                                        handlelanguageid(
                                          skill.id,
                                          skill.description
                                        )
                                      }
                                    />
                                  )}
                                </>
                              </span>
                              <div
                                className="modal fade mt-5"
                                id="exampleModalmiddle"
                                tabIndex="-1"
                                role="dialog"
                                aria-labelledby="exampleModalLabelmiddle"
                                aria-hidden="true"
                              >
                                <div className="modal-dialog" role="document">
                                  <div className="modal-content">
                                    <div className="modal-body">
                                      <h3>
                                        Do you want to delete
                                        <strong>
                                          {" " + languagename + " "}
                                        </strong>{" "}
                                        Language?
                                      </h3>
                                    </div>

                                    <div className="modal-footer p-3">
                                      <Button
                                        type="button"
                                        color="primary"
                                        size="sm"
                                        outline
                                        data-dismiss="modal"
                                      >
                                        Close
                                      </Button>
                                      <Button
                                        type="button"
                                        color="primary"
                                        size="sm"
                                        outline
                                        data-dismiss="modal"
                                        onClick={() => {
                                          removeSkillDetails();
                                        }}
                                      >
                                        Delete
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </Colxx>
                      </FormGroup>
                    </Form>
                  </Colxx>
                </Row>
              );
            })}
          </CardBody>
        </Card>
      )}
    </div>
  );
};

export default LanguagesList;
